import { useQuery, useMutation, useQueryClient } from "react-query"
import qs from "query-string"

import { apiRequest } from "util/request"
import { SegmentsPayload } from "util/retargeting"

/** ------------------- **/
/*  Audiences
/** ------------------- **/

export function useAudiences({
  startDate,
  endDate,
}: {
  startDate: string
  endDate: string
}) {
  const cacheKey = ["audiences"]
  const paramsString = qs.stringify({
    start_date: startDate,
    end_date: endDate,
  })
  const query = () => apiRequest(`audience/list_audiences?${paramsString}`)
  return useQuery(cacheKey, query, {
    meta: {
      disableCache: true,
    },
  })
}

export function useCreateAudience() {
  const queryClient = useQueryClient()
  return useMutation(
    (segments: SegmentsPayload) => {
      return apiRequest(`audience/create`, "POST", { segments })
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries(["audiences"])
        queryClient.refetchQueries(["segments"])
      },
    }
  )
}

export function useSegments() {
  const cacheKey = ["segments"]
  const query = () => apiRequest(`audience/list_customer_segments`)
  return useQuery(cacheKey, query)
}
